module.exports = flarum.core.compat['components/HeaderPrimary'];